import type { SituacaoDistribuicaoDialogProps } from "./types-situacao-distribuicao-dialog";
import { useSituacaoDistribuicaoDialog } from "./use-situacao-distribuicao-dialog";
import { SituacaoDistribuicaoDialogView } from "./view-situacao-distribuicao-dialog";

export function SituacaoDistribuicaoDialog(props: SituacaoDistribuicaoDialogProps) {
  const vm = useSituacaoDistribuicaoDialog(props);

  return <SituacaoDistribuicaoDialogView {...vm} />;
}

export type * from "./types-situacao-distribuicao-dialog";
